var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50.0 50.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1920,0 L1920,1259 L0,1259 L0,0 L1920,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,0 C38.8071187,-2.53632657e-15 50,11.1928813 50,25 C50,38.8071187 38.8071187,50 25,50 C11.1928813,50 1.69088438e-15,38.8071187 0,25 C-1.69088438e-15,11.1928813 11.1928813,2.53632657e-15 25,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.46,0 C11.64,0.02 11.8,0.1 11.92,0.22 L17.69,5.97 C17.83,6.11 17.91,6.3 17.91,6.5 L17.91,9.87 L16.41,9.87 L16.41,7.26 L11.4,7.26 C11.2,7.26 11.01,7.18 10.87,7.04 C10.73,6.9 10.65,6.71 10.65,6.51 L10.65,1.5 L1.52,1.5 L1.52,22.35 L16.42,22.35 L16.42,20.01 L17.92,20.01 L17.92,23.1 C17.92,23.3 17.85,23.49 17.69,23.61 C17.55,23.75 17.36,23.83 17.16,23.83 L0.75,23.83 C0.55,23.83 0.36,23.75 0.22,23.61 C0.08,23.47 0,23.28 0,23.08 L0,0.75 C0,0.55 0.08,0.36 0.22,0.22 C0.36,0.08 0.55,0 0.75,0 Z M12.16,2.56 L12.16,5.77 L15.37,5.77 L12.16,2.56 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3374151,0.00107142857 C8.5374151,0.0110714286 8.7274151,0.101071429 8.8574151,0.251071429 L11.0374151,2.74107143 C11.1674151,2.89107143 11.2274151,3.08107143 11.2174151,3.28107143 C11.2074151,3.48107143 11.1174151,3.67107143 10.9674151,3.80107143 L3.9974151,9.91107143 C3.8774151,10.0310714 3.7174151,10.0910714 3.5474151,10.1010714 L0.8074151,10.2610714 L0.7474151,10.2610714 C0.5274151,10.2610714 0.3074151,10.1610714 0.1674151,9.98107143 C0.0274150999,9.80107143 -0.0325849001,9.57107143 0.0174150999,9.35107143 L0.5574151,6.70107143 C0.5974151,6.54107143 0.6774151,6.40107143 0.8074151,6.29107143 L7.7974151,0.181071429 C7.9474151,0.0510714286 8.1374151,-0.00892857143 8.3374151,0.00107142857 Z M8.2174151,1.80107143 L1.9874151,7.26107143 L1.6874151,8.70107143 L3.1874151,8.61107143 L9.4074151,3.16107143 L8.2174151,1.80107143 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.01,0 L5.01,1.5 L0,1.5 L0,0 L5.01,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.03,0 L10.03,1.5 L0,1.5 L0,0 L10.03,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.02,0 L7.02,1.5 L0,1.5 L0,0 L7.02,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1650.0 -15.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1650.0 15.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 50,0 50,50 0,50 0,0",
    stroke: "none",
    fill: "#FFFFFF",
    opacity: "25.1306443%"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.00000000000013 13.000000000000853)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 17.92,0 17.92,23.83 0,23.83 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.63258490012231 9.618928571429024)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "1.13686838e-13,-2.16840434e-19 11.2184865,-2.16840434e-19 11.2184865,10.2610714 1.13686838e-13,10.2610714 1.13686838e-13,-2.16840434e-19",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.709999999999127 8.159999999999854)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 5.01,0 5.01,1.5 0,1.5 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.710000000002765 11.67000000000007)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 10.03,0 10.03,1.5 0,1.5 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.710000000002765 15.18000000000029)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.02,0 7.02,1.5 0,1.5 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.710000000002765 18.6899999999996)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 7.02,0 7.02,1.5 0,1.5 0,0",
    stroke: "none",
    fill: "#FFFFFF"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/note-icon.00da631d7dd87a52e4500432ca2e447c.svg";
export { ForwardRef as ReactComponent };